module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/ja.json
// module id = 547
// module chunks = 0